import { DateInputV2 } from "@inputs/date/DateInputV2";
import { Stack, Switch, Typography } from "@mui/material";
import { useI18nContext } from "@root/utils/organisation";
import { StackGrid } from "@styleguide";
import { ContactInput } from "../components/contact";
import { EnterpriseInput } from "../components/enterprise";
import { useModalOfferContext } from "../context";

export const EnterpriseSection = () => {
  const { apply, setApply, followUpDate, setFollowUpDate } = useModalOfferContext();
  const { timeZone } = useI18nContext();

  return (
    <>
      <Typography variant="subtitle2SemiBold" color="primary">
        Entreprise
      </Typography>
      <EnterpriseInput />
      <ContactInput />
      {apply.status === "success" && (
        <>
          <Stack
            direction="row"
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Stack>
              <Typography variant="body1Bold">Souhaitez-vous générer une action de suivi en emploi ?</Typography>
              <Typography variant="body1">Vous pourrez la retrouver sur la fiche candidat</Typography>
            </Stack>
            <Switch
              size="small"
              checked={apply.isFollowUpGenerated}
              onChange={() => setApply((apply) => ({ ...apply, isFollowUpGenerated: !apply.isFollowUpGenerated }))}
              color="primary"
            />
          </Stack>
          <StackGrid perLine={2} gap={2}>
            {apply.isFollowUpGenerated && (
              <DateInputV2
                label="Date de prochain suivi*"
                value={followUpDate ? new Date(followUpDate) : null}
                onChange={setFollowUpDate}
                TextFieldProps={{ size: "small" }}
                timeZone={timeZone}
              />
            )}
          </StackGrid>
        </>
      )}
    </>
  );
};
